import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import "../Style/Programmes.css";
import "../Style/Responsive.css";
// import Chatbot from "./Chatbot";
import '../utils/axiosConfig'; // runs the 401/403 logout logic globally
import { formatDescription } from '../utils/formatDescription';
import {
  FaArrowRight,
  FaMapMarkerAlt,
} from "react-icons/fa";

// Program category icons
import kpmgMasterIcon from "../icons/KPMGMasterPrograms-icon.png";
import externalProgramsIcon from "../icons/ExternalPrograms-icon.png";
import mentorshipIcon from "../icons/Mentorship&FounderSessions-icon.png";
import pitchCoachingIcon from "../icons/PitchCoaching-icon.png";

//Programs images
import marketImg from "../Images/market-access.png";
import financeImg from "../Images/financial-management.png";
import strategicImg from "../Images/strategic-management.png";
import advancedtax from "../Images/Advanced Tax Strategies.jpg";
import taxImg from "../Images/regulatory-tax.png";
import workforceImg from "../Images/workforce-management.png";
import techImg from "../Images/business-technology.png";
import opsImg from "../Images/operations-management.png";
import govImg from "../Images/governance.png";
import digtrans from "../Images/Digital Tax Transformation.png";
import funtax from "../Images/Fundamentals of Taxation.jpg";
import taxtech from "../Images/Tax Tech Bootcamp.png";
import kpmgacademy from "../Images/CPE-Training-kpmg academy.png";
import strathmorefamilybiz from "../Images/strathmore-familybiz.png";
import KPMGExecutive from "../Images/KPMG Executive Masterclass.webp";
import KPMGStrategic from "../Images/KPMG exec Masterclass.jpg";
import leader from "../Images/leadership-leader.jpg";

// Tech Innovator Section with images instead of videos
import GTI from '../Images/GTI.png';

function ProgrammesPage() {
  const { t } = useLanguage();
  // State for the currently selected category and search term
  const [selectedCategory, setSelectedCategory] = useState('');
   const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  // Define your four main categories with icons + KPMG accent palette
  const categories = [
    {
      id: 'kpmg-master',
      title: 'KPMG Master Programs',
      tagline: 'Premier KPMG-led training across business disciplines.',
      icon: kpmgMasterIcon,
      accent: '#00338D',
      paid: true,
    },
    {
      id: 'external-programs',
      title: 'External Programs',
      tagline: 'Curated partner programs across the African ecosystem.',
      icon: externalProgramsIcon,
      accent: '#7213EA',
      paid: true,
      subCategories: [
        { id: 'ecosystem-programs', title: 'Ecosystem Programs' },
        { id: 'family-business-programs', title: 'Family Business Programs' },
      ],
    },
    {
      id: 'mentorship',
      title: 'Mentorship & Founder Sessions',
      tagline: '1:1 guidance from seasoned founders, advisors and operators.',
      icon: mentorshipIcon,
      accent: '#FD349C',
      free: true,
    },
    {
      id: 'pitching',
      title: 'Pitch Coaching',
      tagline: 'Sharpen your story and present with confidence to investors.',
      icon: pitchCoachingIcon,
      accent: '#00C0AE',
      paid: true,
    },
  ];

  // Verifiable facts only — no fabricated impact numbers. Update when
  // we have audited platform metrics worth publishing.
  const STATS = [
    { value: '21+', label: 'Programs available' },
    { value: '4', label: 'Program tracks' },
    { value: 'Pan-African', label: 'Reach' },
    { value: 'KPMG-led', label: 'Curation & advisory' },
  ];

  // Sample programmes data with category assignments
  const programmesData = [
  
   // --- Existing Paid KPMG Masterclasses ---
      {
      title: 'KPMG Learning Academy',
      provider: 'KPMG',
      description: [
        "The KPMG Learning Academy combines an extensive amount of subject matter expertise with a number of tried and tested training programmes.",
        "We provide diverse educational and training programmes which include professional accounting and financial training, postgrad and undergraduate degrees.",
        
      "KPMG Learning Academy is licensed as a Further and Higher Education Institution (License number: 2017 – 010) by the Malta Further & Higher Education Authority."
    ],

      link: 'https://kpmglearningmalta.com/',
      image: kpmgacademy,
      category: 'kpmg-master',
    },
    {
      title: 'KPMG Executive Masterclass',
      provider: 'KPMG',
      description: 'A premium programme tailored for business executives.',
      link: '/login',
      image: KPMGExecutive,
      category: 'kpmg-master'
    },
    {
      title: 'KPMG Strategic Master Programme',
      provider: 'KPMG',
      description: 'A comprehensive programme focusing on strategic business growth.',
      link: '/login',
      image: KPMGStrategic,
      category: 'kpmg-master',
    },
    {
      title: 'KPMG Leadership Master Programme',
      provider: 'KPMG',
      description: 'Develop leadership skills with our industry experts.',
      link: '/login',
      image: leader,
      category: 'kpmg-master',
    },
    // --- NEW Master Classes ---
    {
      title: 'Access to Market',
      provider: 'KPMG',
      description: `Equip yourself to position products globally: build your marketing plan, 
       leverage e-commerce and CRM, and launch structured export strategies.`,
       link: '/login',
      image: marketImg,
      category: 'kpmg-master',
    },
    {
      title: 'Financial Management',
      provider: 'KPMG',
      description: `Master budgeting, cash management, forecasting, credit control and 
financial reporting to drive informed decisions.`,
link: '/login',
      image: financeImg,
      category: 'kpmg-master'
    },
    {
      title: 'Strategic Management',
      provider: 'KPMG',
      description: `Learn vision & mission crafting, SWOT and competitive analysis,
plus strategic sourcing & procurement optimization.`,
link: '/login',
      image: strategicImg,
      category: 'kpmg-master',
    },
    {
      title: 'Regulatory & Tax Compliance',
      provider: 'KPMG',
      description: `Navigate Ghana’s GRA & SSNIT obligations and build a robust compliance framework.`,
      link: '/login',
      image: taxImg,
      category: 'kpmg-master',
    },
    {
      title: 'Workforce Management',
      provider: 'KPMG',
      description: `From recruitment to performance appraisals and legal compliance,
create HR systems that foster growth.`,
link: '/login',
      image: workforceImg,
      category: 'kpmg-master',
    },
    {
      title: 'Operations Management',
      provider: 'KPMG',
      description: `Apply due diligence, rapid assessments and Kaizen to streamline operations 
and boost productivity.`,
link: '/login',
      image: opsImg,
      category: 'kpmg-master',
    },
    {
      title: 'Governance',
      provider: 'KPMG',
      description: `Understand board structures, ethical leadership, ESG integration and CSR strategies 
for sustainable success.`,
link: '/login',
      image: govImg,
      category: 'kpmg-master',
    },

  {title: 'Business Technology & Implementation',
  provider: 'KPMG',
  description: `Practical, hands-on training to modernize your business stack:
- IT fundamentals for non-IT teams (governance, policies, risk)
- Implementing core processes (IDAM, backups, DR, change control)
- ERP/CRM selection & rollout basics
- Automation with low-code/RPA and workflow tools
- Data management & analytics foundations
- Cyber hygiene and data privacy by design
- Social, collaboration, and AI tools for productivity
By the end, you’ll map current processes, design a target operating model, and ship a 90-day implementation plan.`,
link: '/login',
  image: techImg,
  category: 'kpmg-master',
},
{
  title: 'Tax Technology & GenAI Adoption',
  provider: 'KPMG',
  description: `Train your tax & finance teams to deliver a digitized, data-driven tax function:
- End-to-end tax process mapping (direct, indirect, payroll)
- Automation of compliance workflows (extractions, validations, filings)
- VAT/PAYE/WHT use cases with analytics & dashboards
- Data quality, controls, and audit trails across ERP
- E-invoicing, digital reporting, and authority integrations
- GenAI for tax research, document review, and reconciliation assistance
- Operating model, roadmap, and change management
Capstone: build a live prototype (automation + dashboard) and a 6-month tax-transformation roadmap.`,
link: '/login',
  image: taxtech,
  category: 'kpmg-master',
},
   
            // --- KPMG Learning Academy ---
     {
      title: 'KPMG Learning Academy',
      provider: 'KPMG',
      description: [
        "The KPMG Learning Academy combines an extensive amount of subject matter expertise with a number of tried and tested training programmes.",
        "We provide diverse educational and training programmes which include professional accounting and financial training, postgrad and undergraduate degrees.",
        
      "KPMG Learning Academy is licensed as a Further and Higher Education Institution (License number: 2017 – 010) by the Malta Further & Higher Education Authority."
    ],

      link: '/login',
      image: kpmgacademy,
      category: 'kpmg-master',
    },
    // Free Programmes
    {
      title: 'Antler Global Founder Program',
      provider: 'Antler',
      description:
        'Launch your startup with support from a global community of entrepreneurs and investors.',
      link: '/login',
      image:
        'data:image/png;base64,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',
      category: 'ecosystem-programs',
    },
     {
      title: 'Launch Africa Accelerator',
      provider: 'Launch Africa',
      description: 'Launch your startup with support from a global community of entrepreneurs and investors.',
      link:   '/login',
      image: 'https://images.squarespace-cdn.com/content/v1/64a7a29028c7470d7e976389/01451a71-eb15-4b7e-9ce4-dd42eb86dc2a/Launch+Africa+Logo%402x.png?format=1500w',
      category:  'ecosystem-programs'
    },
        // — Family Business Programs — Strathmore —
  {
    title: "Family Business Executive Programme",
    provider: "Strathmore University Business School",
    description: [
    "“Familiness” is a resource that can create uniqueness and a critical source of competitive advantage to a business.",
      "Almost all companies start as family businesses, but only those that master the challenges intrinsic to this form of ownership endure growth, maintain collegiality and harmony as a family and achieve success in the business.",
      "In the process, they transition successfully across generations and proceed to prosper and diversify into multi-location and multi-industry businesses.",
      "Succession Planning: navigate leadership & ownership transfer smoothly across generations.",
      "Family Dynamics: address communication, conflict resolution and healthy boundaries.",
      "Leadership Development: build decision-making & management skills tailored to family firms.",
      'Financial Management: optimize planning, investment strategy & risk management.',
      "Governance & Strategy: strengthen board structures and long-term strategic planning."
    ],
    link: "/login",
    image: strathmorefamilybiz,
    category: "family-business-programs",
  },

    // Mentorship Trainings
    {
      title: "Startup Founder Mentorship",
      provider: "Mentor Hub",
      description:["Receive personalized one-on-one guidance from seasoned entrepreneurs to refine your business strategy, pitch, and growth plan."],
      link: "/login",
      image: taxtech, 
      category: "mentorship"
    },
    {
      title: "Tech Founder Bootcamp",
      provider: "Innovation Accelerator",
      description:["An intensive bootcamp designed for tech founders to accelerate startup growth through strategic mentorship and peer networking."],
      link: "/login",
      image: digtrans,
      category: "mentorship"
    },
    {
      title: "Scaling Strategies Mentorship",
      provider: "Venture Connect",
      description: [
        "Learn proven strategies to scale your business from successful founders and industry experts, with tailored mentorship sessions.",
        
      ],
      link: "/login",
      image: funtax,
      category: "mentorship"
    },
    

    // Pitch Coaching
    {
      title: 'Pitch Fundamentals Workshop',
      provider: 'Ecosystem Partners',
      description: [
        "Understanding your audience (investors, partners, clients)",
        "Structuring the pitch: problem, solution, market, traction, team, and ask",
        "Articulating a compelling value proposition"
      ],
      link: '/login',
      image: funtax,
      category: 'pitching',
    },
    {
      title: 'Elevator Pitch Drills',
      provider:'Ecosystem Partners',
      description: [
        "Crafting a memorable hook",
        "Communicating value in simple terms",
        "Balancing detail vs. brevity"
      ],
      link: '/login',
      image: advancedtax,
      category: 'pitching',
    }

  ];

  // Filter programmes based on the selected category and search term
  const activeCategory = selectedSubCategory || selectedCategory;
  const filteredProgrammes = programmesData.filter(
    p =>
      p.category === activeCategory &&
      (p.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
       p.provider.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleSearchChange = e => setSearchTerm(e.target.value);

  // If no category is selected, show the category selection view
  if (!selectedCategory) {
    return (
      <div className="programmes-container">
        <header className="programmes-header">
          <span className="programmes-eyebrow">{t('programs_title')}</span>
          <h1>{t('programs_subtitle')}</h1>
          <p>
            Curated training, mentorship and pitch programs designed for
            founders, investors and ecosystem partners — connecting expertise,
            capital and opportunity across the continent.
          </p>
          <div className="programmes-stats">
            {STATS.map((s) => (
              <div key={s.label} className="programmes-stat">
                <div className="programmes-stat-value">{s.value}</div>
                <div className="programmes-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </header>

        <div className="categories-grid">
          {categories.map((cat) => {
            return (
              <button
                key={cat.id}
                type="button"
                className="category-card"
                style={{ '--accent': cat.accent }}
                onClick={() => {
                  setSelectedCategory(cat.id);
                  setSelectedSubCategory('');
                }}
              >
                <span className="category-card-icon" aria-hidden="true">
                  <img src={cat.icon} alt="" />
                </span>
                <h3>{cat.title}</h3>
                <p className="category-card-tagline">{cat.tagline}</p>
                <span className="category-card-cta">
                  {t('explore')} <FaArrowRight />
                </span>
              </button>
            );
          })}
        </div>
    

    
   {/* KPMG Private Enterprise Tech Innovator Section */}
<section className="tech-innovator-section" id="tech-innovator">
  <header className="tech-innovator-header">
    <span className="programmes-eyebrow">Flagship Competition</span>
    <h2>Global Tech Innovator</h2>
    <p>
      KPMG Private Enterprise's flagship competition for tech founders breaking
      new ground across Africa — connecting them with global mentorship, investor
      networks and recognition.
    </p>
  </header>

  <div className="tech-innovator-container">
    {[
      {
        title: "Tech Innovator — East Africa",
        region: "Kenya · Uganda · Tanzania · Rwanda · Ethiopia",
        regionTag: "East Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#00338D",
        description:
          "Pitch and showcase your tech innovation with KPMG's guidance and a network of global investors. View past finalists and watch this space for the next intake.",
        url: "https://kpmg.com/ke/en/insights/2025/06/kpmg-private-enterprise-tech-innovator-in-east-africa.html",
        ctaLabel: "View past edition",
      },
      {
        title: "Tech Innovator — West Africa",
        region: "Ghana",
        regionTag: "West Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#7213EA",
        description:
          "Seeking the region's top tech entrepreneurs and visionaries — with insights, mentorship and global recognition. View past edition details below.",
        url: "https://kpmg.com/gh/en/insights/technology-and-innovation/KPMG-Global-Tech-Innovator-Terms-and-Conditions.html",
        ctaLabel: "View past edition",
      },
      {
        title: "Tech Innovator — Southern Africa",
        region: "South Africa",
        regionTag: "Southern Africa",
        status: "closed",
        statusLabel: "Applications closed",
        accent: "#FD349C",
        description:
          "Showcase your cutting-edge solutions and connect with industry leaders and investors driving growth across the region. View past edition for context.",
        url: "https://kpmg.com/za/en/insights/2025/04/global-tech-innovator-2025.html",
        ctaLabel: "View past edition",
      },
    ].map((c) => (
      <div
        key={c.title}
        className="innovator-card"
        style={{ "--accent": c.accent }}
      >
        <div className="innovator-image">
          <img src={GTI} alt={c.title} loading="lazy" />
          <span className={`innovator-status status-${c.status}`}>
            {c.statusLabel}
          </span>
        </div>
        <div className="innovator-card-body">
          <span className="innovator-region-chip">
            <FaMapMarkerAlt aria-hidden="true" /> {c.regionTag}
          </span>
          <h3>{c.title}</h3>
          <p className="innovator-region-detail">{c.region}</p>
          <p>{c.description}</p>
          <a
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            {c.ctaLabel || "More info"} <FaArrowRight />
          </a>
        </div>
      </div>
    ))}
  </div>
</section>
      </div>
    );
  }
 // 2) External Programs selected, but no sub-category yet → show sub-categories
  const mainCat = categories.find(c => c.id === selectedCategory);
  if (selectedCategory === 'external-programs' && !selectedSubCategory) {
    return (
      <div className="programmes-container">
        <header className="programmes-header">
          <h1>{mainCat.title}</h1>
          <p>Choose a track under External Programs:</p>
          <button
            className="back-button"
            onClick={() => setSelectedCategory('')}
          >
            &larr; Back to Categories
          </button>
        </header>
        <div className="categories-grid">
          {mainCat.subCategories.map(sub => (
            <div
              key={sub.id}
              className={`category-card ${sub.id}-card`}
              onClick={() => setSelectedSubCategory(sub.id)}
            >
              <h3>{sub.title}</h3>
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  // 3) some other main category, or we've picked our sub-category → show programmes
  const headerTitle = selectedSubCategory
    ? mainCat.subCategories.find(s => s.id === selectedSubCategory).title
    : mainCat.title;

  return (
    <div className="programmes-container">
      <header className="programmes-header">
        <h1>{headerTitle}</h1>
        <p>Explore our curated programmes for {headerTitle}.Subject-matter experts in these areas will facilitate the training sessions using modern collaborative teaching methods to encourage active participation among the participants. Startups will get comprehensive support to refine and present their business ideas to investors, including pitch coaching and storytelling techniques.</p>
        <button
          className="back-button"
          onClick={() => {
            if (selectedSubCategory) {
              setSelectedSubCategory('');
            } else {
              setSelectedCategory('');
            }
            setSearchTerm('');
          }}
        >
          &larr; Back
        </button>
        <div className="search-bar">
          <input
            type="text"
            placeholder={t('search_placeholder')}
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </header>

      <div className="programmes-grid">
        {filteredProgrammes.map((program, i) => (
          <div key={i} className="programme-card">
            <div className="programme-image">
              <img src={program.image} alt={program.title} />
            </div>
            <div className="programme-info">
              <h3>{program.title}</h3>
              <p className="provider">Provider: {program.provider}</p>
              <div className="description">
                {formatDescription(program.description)}
              </div>
              {program.link.startsWith('/')
                ? <button
                    className="programme-link"
                    onClick={() => window.location.href = program.link}
                  >
                    Learn More
                  </button>
                : <a
                    href={program.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="programme-link"
                  >
                    Learn More
                  </a>
              }
            </div>
          </div>
        ))}
      </div>

      {/* Chatbot */}
      {/* <Chatbot /> */}

    </div>
  );
}

export default ProgrammesPage;
